export function SkipToContent() {
  return (
    <a className="skip-link" href="#main-content">
      Skip to main content
    </a>
  );
}
